const LOCALIZED_ERROR_MESSAGES = {
  unauthorized: 'Die Anmeldung ist fehlgeschlagen. Bitte überprüfen Sie Benutzername und Passwort.',
  validation_failed: 'Überprüfung der Daten fehlgeschlagen.',
  ECONNABORTED: 'Zeitüberschreitug der Anforderung'
};

const LICENSE_MODULES = Object.freeze({
  RPTRADE: 'RP Trade',
  AVG: 'Sensis AVG BTB',
  AVGR: 'AVG-R',
  SENSIS_SHIFT_PLANS: 'Sensis Shift plans',
  GMVA: 'GMVA BTB',
  DIGITAL35: 'Digital 35',
  EKAV: 'eKAV',
  SALES: 'Sales',
  REPORTS: 'Reports',
  ONE: 'One',
  TICKETS: 'Tickets',
  VIEW: 'View'
});

const ROLES = Object.freeze({
  ADMIN: 'admin',
  USER: 'user'
});

const ROLE_AVAILABLE_LICENSE_MODULES = Object.freeze({
  [ROLES.ADMIN]: [
    LICENSE_MODULES.AVG,
    LICENSE_MODULES.AVGR,
    LICENSE_MODULES.SENSIS_SHIFT_PLANS,
    LICENSE_MODULES.GMVA,
    LICENSE_MODULES.DIGITAL35,
    LICENSE_MODULES.EKAV,
    LICENSE_MODULES.RPTRADE,
    LICENSE_MODULES.SALES,
    LICENSE_MODULES.REPORTS,
    LICENSE_MODULES.ONE,
    LICENSE_MODULES.TICKETS,
    LICENSE_MODULES.VIEW
  ],
  [ROLES.USER]: [LICENSE_MODULES.RPTRADE]
});

module.exports = { LOCALIZED_ERROR_MESSAGES, LICENSE_MODULES, ROLES, ROLE_AVAILABLE_LICENSE_MODULES };
